import { h, Host } from "@stencil/core";
/** @internal */
export class Popper {
    render() {
        return h(Host, { key: 'eff236196d54dee549df39bb9374685d3eef811c' });
    }
    static get is() { return "es-popper-x"; }
}
//# sourceMappingURL=es-popper-x.js.map
